/* eslint-disable max-len */
import { MedicalCross, PointerArrow, BoldDollar } from 'components/svg';

export const BADGES = {
	omi: {
		rank: 1,
		name: 'E-RENTAL',
		color: 'orange',
		icon: PointerArrow,
		tooltipMessage:
			'Rent online, skip the counter and go straight to your space.',
		facilityMessage:
			'Rent online, skip the counter and go straight to your space.',
	},
	omiBadge: {
		rank: 1,
		name: 'RENT ONLINE',
		color: 'orange',
		icon: PointerArrow,
		tooltipMessage:
			'Complete your rental process online today and go straight to your unit when you plan to move in.',
		facilityMessage:
			'Complete your rental process online today and go straight to your unit when you plan to move in.',
	},
	contactless: {
		rank: 4,
		name: 'CONTACTLESS',
		color: 'blue',
		icon: MedicalCross,
		tooltipMessage:
			'Facilities with this badge offer contactless move-ins.',
		facilityMessage: 'This facility provides contactless move-ins.',
	},
	giftcard: {
		rank: 5,
		name: 'GIFT CARDS',
		color: 'green',
		icon: BoldDollar,
		tooltipMessage: (giftCardValue) => {
			return `Get a $${giftCardValue} gift card when you rent select units online.`;
		},
		facilityMessage: (giftCardValue) => {
			return `Get a $${giftCardValue} gift card when you rent select units online.`;
		},
	},
};
